import React from "react";
import AminoAcidSequence from "./AminoAcidSequence.js";
import { faDownload, faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StatsBox from "../StatsPage/StatsBox.js";


const AminoAcidDisplay = ({ sequence, enzymeInfo, ddxxd, dxdd, nsedte, nsedteExp }) => {
  

  const copyToClipboard = () => {
    navigator.clipboard.writeText(sequence);
  };

  const downloadFASTA = () => {
    const fastaContent = `>${enzymeInfo.marts}|${enzymeInfo.name}|${enzymeInfo.species}\n${sequence}`;
    const blob = new Blob([fastaContent], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${enzymeInfo.marts}.fasta`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const allHighlights = [...(ddxxd || []), ...(dxdd || []), ...(nsedte || []), ...(nsedteExp || [])];

  return (
    <>
       <div style={{marginBottom: "10px"}}>
        <button onClick={copyToClipboard} className="basic-button"><FontAwesomeIcon icon={faCopy} /> Copy</button>
        <button onClick={downloadFASTA} className="basic-button"><FontAwesomeIcon icon={faDownload} /> Download FASTA</button>
      </div>
      <div className="sequence-info">
        <AminoAcidSequence sequence={sequence} highlights={allHighlights} blockSize={10} />
      </div>
      {allHighlights.length > 0 && (
      <StatsBox title={"Potential structural motifs"}>
        {ddxxd?.length > 0 && <p>DDXXD: {ddxxd.map(([start, end]) => `${start + 1}-${end}`).join(", ")}</p>}
        {dxdd?.length > 0 && <p>DXDD: {dxdd.map(([start, end]) => `${start + 1}-${end}`).join(", ")}</p>}
        {nsedte?.length > 0 && <p>NSE/DTE: {nsedte.map(([start, end]) => `${start + 1}-${end}`).join(", ")}</p>}
        {nsedteExp?.length > 0 && <p>NSE/DTE expanded: {nsedteExp.map(([start, end]) => `${start + 1}-${end}`).join(", ")}</p>}
      </StatsBox>)}
    </>
  );
};

export default AminoAcidDisplay;